// import authService from '../auth/authService';
import authService from '../repository/auth'

export default {
  install(Vue) {
    Vue.prototype.$auth = authService

    Vue.mixin({
      created() {
        if (this.handleLoginEvent) {
          authService.addListener('loginEvent', this.handleLoginEvent)
        }
      },

      destroyed() {
        if (this.handleLoginEvent) {
          authService.removeListener('loginEvent', this.handleLoginEvent)
        }
      },

      data() {
        return {
          basicObject: {
            alert: {
              urgent: {
                accident: false,
                geofence_in: false,
                geofence_out: false,
                overstay_engine_on: false,
                overstay_engine_off: false,
                main_battery_disconnected: false,
                accu_high: false,
                accu_low: false,
                freezer_temp_low: false,
                freezer_temp_high: false,
                chiller_temp_low: false,
                chiller_temp_high: false,
              },
              summary: {
                overspeed: false,
                harsh_break: false,
                harsh_acceleration: false,
                // harsh_cornering: false,
                
                towing_detected: false,
                smoking: false,
                seatbelt: false,
                occlusion: false,
                fatigueWarn: false,
                driverChange: false,
                fatigueAlarm: false,
                identification: false,
                handheldPhoneCall: false,
                harsh_acceleration: false,
                longTimeWithoutLookingAhead: false,
                "matching_fail":false
              },
              alert_pop_up_notification: {
                pop_up_notification: false,
                sound: false,
              },
              alert_history: {
                access_to_alert: true,
                enable_download: false,
              },
            },
            dashboard_analytics: {
              urgent: {
                accident_event: true,
                main_battery_disconnected_event: true,
                overstay_engine_on_event: true,
                overstay_engine_off_event: true,
                geofence_in_event: true,
                geofence_out_event: true,

                overstay_precentages: true,
                geofence_precentages: true,
                temperature_precentages: true,
              },
              summary: {
                total_overspeed_event: true,
                total_harsh_acceleration_event: true,
                total_harsh_brake_event: true,

                top_10_overspeed_fleet_group: true,
                top_10_harsh_acceleration_fleet_group: true,
                top_10_harsh_brake_fleet_group: true,
                top_10_accident_fleet_group: true,
                top_10_verified_alert_fleet_group: true,
                top_10_unverified_alert_fleet_group: true,
              },
              analytics: {
                total_overspeed_event: true,
                total_harsh_acceleration_event: true,
                total_harsh_brake_event: true,
                total_accident_event: true,
                total_verified_alert_event: true,
                total_unverified_alert_event: true,
                main_battery_disconnected_event: true,
                overstay_engine_off_event: true,
                overstay_engine_on_event: true,
                geofence_out_event: true,
                total_not_yet_verified_alert_event: true,
                over_temperature_event: true,
                // rear_door_open_event: true,

                vehicle_status: true,
                unit_on_operation: true,
                status_alert: true,
                total_ritation: false,
                top_10_overspeed_fleet_group: true,
                overstay_precentages: true,
                utilization_rate: true,
              },
            },
            dashboard: {
              maps: {
                google_maps: false,
                openstreet_maps: true,
              },
              header_dashboard: {
                enable_download: false,
                fleet_group: true,
                license_plate: true,
                vehicle_model: true,
                vehicle_number: true,
                imei: true,
                driver: true,
                speed: true,
                last_update: true,
                address: true,
                duration: true,
                action: true,
              },
            },
            vehicle_details: {
              vehicle_informations: {
                read_vehicle_details: true,
                gps_date: true,
                fleet_group: true,
                license_plate: true,
                imei: true,
                vehicle_model: true,
                driver_name: true,
                driver_phone: true,
                location: true,
              },
              vehicle_status: {
                event_name: true,
                speed: true,
                read_odometer: true,
                tms_odometer: true,
                tms_deviasi_odometer: true,
                kalibrasi_odometer: true,
                tms_last_update: true,
                fuel: true,
                direction: true,
                internal_battery: true,
                external_battery: true,
                engine_temp: true,
                chiller_temp: true,
                humidity: true,
                battery_level: true,
                rpm: true,
                engine_status: true,
                sos: true,
                door_status: true,
                fatigue: true,
              },
              main_feature: {
                overviews: true,
                live_track: true,
                periodic_track: true,
                historical_trip: false,
                timeline: false,
                live_cam: false,
                dashcam_alert: false,
                commands: false,
              },
              periodic_track: {
                show_graph: true,
                show_speed: true,
                show_ignition: true,
                show_accu_voltage: true,
                show_fuel: true,
                show_temp: true,
              },
            },
          },
          mapping: {
            overspeed: 'OVERSPEED',
            harsh_break: 'HARSH_BRK',
            harsh_acceleration: 'HARSH_ACC',
            towing_detected: 'TOWING_DETECTED',
            accident: 'CRASH',
            geofence_in: 'GEO_IN',
            geofence_out: 'GEO_OUT',
            overstay_engine_on: 'OVERSTAY_ENGINE_ON',
            overstay_engine_off: 'OVERSTAY_ENGINE_OFF',
            main_battery_disconnected: 'MB_CN',
            accu_high: 'ACCU_HIGH',
            accu_low: 'ACCU_LOW',
            freezer_temp_low: 'FREEZER_TEMP_LOW',
            freezer_temp_high: 'FREEZER_TEMP_HIGH',
            chiller_temp_low: 'CHILLER_TEMP_LOW',
            chiller_temp_high: 'CHILLER_TEMP_HIGH',
            harsh_acceleration: 'harsh_acceleration',
            'smoking': 'smoking',
            'seatbelt': 'seatbelt',
            'occlusion': 'occlusion',
            'fatigueWarn': 'fatigueWarn',
            'driverChange': 'driverChange',
            'fatigueAlarm': 'fatigueAlarm',
            'identification': 'identification',
            'handheldPhoneCall': 'handheldPhoneCall',
            'longTimeWithoutLookingAhead': 'longTimeWithoutLookingAhead',
            "matching_fail":"Matching Fail"
            // over_temperature: 'OVERTEMP',
            // harsh: 'HARSH',
            // poi_in: 'POI_IN',
            // driver_change: 'DRIVER_CHANGE',
            // overchiller_temperature: 'OVERCHILLER_TEMP',
            // mb_rn: 'MB_RN',
            // panic_off: 'PANIC_OFF',
            // sampling: 'SAMPLING',
            // panic_on: 'PANIC_ON',
            // fatigue_off: 'FATIGUE_OFF',
            // engine_off: 'ENGINE_OFF',
            // poi_out: 'POI_OUT',
            // engine_on: 'ENGINE_ON',
            // ja_dt: 'JA_DT',
            // underchiller_temp: 'UNDERCHILLER_TEMP',
            // door_rear_open: 'DREAR_OPEN',
            // door_rear_close: 'DREAR_CLOSE',
            // fatigue_on: 'FATIGUE_ON',
            // door_left_open: 'DLEFT_OPEN',
            // mb_lwn: 'MB_LWN',
            // door_left_close: 'DLEFT_CLOSE',
            // rpm_over: 'RPM_OVER',
            // bb_fn: 'BB_FN',
            // red_zone: 'RED_ZONE',
            // door_right_open: 'DRIGHT_OPEN',
            // door_right_close: 'DRIGHT_CLOSE',
            // bb_lwn: 'BB_LWN',
          },
        }
      },

      methods: {
        getUserId() {
          return JSON.parse(localStorage.getItem('userInfo')).id
        },
        getBasicRolePermission() {
          return this.basicObject
        },
        getRolePermission() {
          // Check if user permissions exist in the store
          const userPermissions = this.$store.state.auth.getUserPermissions()

          // Recursive function to merge default permissions with user permissions
          const mergePermissions = (defaultObj, userObj) => {
            for (const key in defaultObj) {
              if (Object.prototype.hasOwnProperty.call(defaultObj, key)) {
                if (
                  typeof defaultObj[key] === 'object' &&
                  defaultObj[key] !== null
                ) {
                  // If the key exists in user permissions and is an object, merge recursively
                  if (
                    userObj &&
                    userObj[key] &&
                    typeof userObj[key] === 'object'
                  ) {
                    mergePermissions(defaultObj[key], userObj[key])
                  } else {
                    // If the key is missing in user permissions, add it
                    userObj[key] = { ...defaultObj[key] }
                  }
                } else {
                  // If the key is missing in user permissions, add it
                  if (!(key in userObj)) {
                    userObj[key] = defaultObj[key]
                  }
                }
              }
            }
          }

          // If user permissions exist and it has all the attributes, return it
          if (userPermissions) {
            mergePermissions(this.basicObject, userPermissions)
            return userPermissions
          }

          // If user permissions don't exist, return the basic role permission
          return { ...this.basicObject }
        },
        getRoleCode() {
          const alert_urgent = Object.keys(
            this.getRolePermission().alert.urgent
          ).filter((key) => {
            return this.getRolePermission().alert.urgent[key]
          })
          const alert_summary = Object.keys(
            this.getRolePermission().alert.summary
          ).filter((key) => {
            return this.getRolePermission().alert.summary[key]
          })

          const alert_config = [...alert_urgent, ...alert_summary].map(
            (perm) => {
              return this.mapping[perm]
            }
          )

          //
          //
          // permlist is an array
          return JSON.stringify(alert_config)
        },
        getMonthlyChange() {
          return JSON.parse(localStorage.getItem('userData')).monthly_change
        },
      },
    })
  },
}
